var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _path67, _path68, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 783,
    height: 584,
    viewBox: "0 0 783 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M782.438 512.835H0.567383V513.226H782.438V512.835Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M733.023 526.628H703.672V527.018H733.023V526.628Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.541 537.355H583.952V537.746H597.541V537.355Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M468.627 531.96H438.353V532.351H468.627V531.96Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.659 531.757H127.121V532.148H194.659V531.757Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.203 531.757H103.305V532.148H113.203V531.757Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M443.075 522.499H296.584V522.89H443.075V522.499Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M371.174 443.092H69.2307C66.8653 443.088 64.5982 442.146 62.9271 440.472C61.256 438.798 60.3174 436.529 60.3174 434.164V9.71699C60.338 7.36516 61.2856 5.11643 62.9545 3.45924C64.6234 1.80205 66.8788 0.87024 69.2307 0.866211H371.174C373.542 0.866211 375.813 1.80694 377.487 3.48145C379.162 5.15595 380.103 7.42707 380.103 9.79518V434.164C380.103 436.532 379.162 438.803 377.487 440.477C375.813 442.152 373.542 443.092 371.174 443.092ZM69.2307 1.17896C66.969 1.1831 64.8013 2.08447 63.2035 3.68521C61.6057 5.28595 60.7083 7.45527 60.7083 9.71699V434.164C60.7083 436.425 61.6057 438.595 63.2035 440.195C64.8013 441.796 66.969 442.697 69.2307 442.702H371.174C373.437 442.697 375.606 441.797 377.206 440.196C378.807 438.596 379.708 436.427 379.712 434.164V9.71699C379.708 7.45383 378.807 5.28455 377.206 3.68426C375.606 2.08396 373.437 1.18309 371.174 1.17896H69.2307Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M709.428 443.092H407.469C405.102 443.088 402.833 442.146 401.16 440.473C399.486 438.799 398.544 436.53 398.54 434.164V9.71699C398.565 7.36374 399.516 5.11502 401.187 3.45826C402.859 1.8015 405.116 0.870196 407.469 0.866211H709.428C711.777 0.874349 714.028 1.80797 715.694 3.46473C717.359 5.12148 718.305 7.36786 718.325 9.71699V434.164C718.325 436.526 717.389 438.793 715.721 440.466C714.053 442.14 711.79 443.084 709.428 443.092ZM407.469 1.17896C405.206 1.18309 403.037 2.08396 401.436 3.68426C399.836 5.28455 398.935 7.45383 398.931 9.71699V434.164C398.935 436.427 399.836 438.596 401.436 440.196C403.037 441.797 405.206 442.697 407.469 442.702H709.428C711.691 442.697 713.86 441.797 715.46 440.196C717.061 438.596 717.961 436.427 717.966 434.164V9.71699C717.961 7.45383 717.061 5.28455 715.46 3.68426C713.86 2.08396 711.691 1.18309 709.428 1.17896H407.469Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.643 30.0768H92.376V255.459H408.643V30.0768Z",
    fill: "#37474F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.49 30.0768H95.1113V255.459H414.49V30.0768Z",
    fill: "#1C262B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.296 246.249V39.2717L103.305 39.2717V246.249L406.296 246.249Z",
    fill: "#37474F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.475 246.249L206.544 39.2717H269.563L221.493 246.249H158.475Z",
    fill: "#37474F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231.688 246.249L279.773 39.2717H308.233L260.148 246.249H231.688Z",
    fill: "#37474F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M406.296 246.249V39.2717H405.248V246.249H406.296Z",
    fill: "#37474F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2285 29.7016V119.022H109.857C109.857 119.022 152.25 91.3286 161.961 34.3615C162.196 32.9971 162.129 31.5978 161.766 30.2619C161.402 28.926 160.75 27.686 159.856 26.6292C158.961 25.5723 157.846 24.7243 156.589 24.1447C155.332 23.5651 153.963 23.2681 152.578 23.2746H92.6555C90.951 23.2746 89.3162 23.9517 88.1109 25.157C86.9056 26.3623 86.2285 27.997 86.2285 29.7016Z",
    fill: "#263942"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2285 283.028V126.231H109.857C109.857 126.231 157.817 218.57 163.368 283.028H86.2285Z",
    fill: "#263942"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.169 119.023H87.0888C85.7847 119.023 84.7275 120.08 84.7275 121.384V123.87C84.7275 125.174 85.7847 126.231 87.0888 126.231H109.169C110.473 126.231 111.53 125.174 111.53 123.87V121.384C111.53 120.08 110.473 119.023 109.169 119.023Z",
    fill: "#1C262B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M421.214 29.7016V119.023H397.539C397.539 119.023 355.083 91.3287 345.435 34.3616C345.202 32.9976 345.271 31.5993 345.635 30.2646C346 28.9299 346.652 27.691 347.546 26.6348C348.44 25.5786 349.554 24.7306 350.81 24.1502C352.066 23.5697 353.434 23.2709 354.817 23.2746H414.802C416.503 23.2829 418.131 23.9631 419.332 25.1671C420.533 26.3711 421.21 28.001 421.214 29.7016Z",
    fill: "#263942"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M421.215 283.028V126.231H397.54C397.54 126.231 349.595 218.57 344.028 283.028H421.215Z",
    fill: "#263942"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M398.227 126.216H420.307C421.611 126.216 422.668 125.159 422.668 123.854V121.368C422.668 120.064 421.611 119.007 420.307 119.007H398.227C396.923 119.007 395.865 120.064 395.865 121.368V123.854C395.865 125.159 396.923 126.216 398.227 126.216Z",
    fill: "#1C262B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M414.068 311.519H362.104V512.835H414.068V311.519Z",
    fill: "#37474F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M400.197 512.835H414.067V489.583H385.654L400.197 512.835Z",
    fill: "#F4F8FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.464 311.519H113.501V512.835H165.464V311.519Z",
    fill: "#263942"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M414.067 311.519H153.36V504.829H414.067V311.519Z",
    fill: "#37474F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M231.688 277.336C231.688 296.101 249.764 311.519 271.876 311.519H291.829C313.925 311.519 332.002 296.132 332.002 277.336H231.688Z",
    fill: "#1C262B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.116 234.38H257.646C257.646 234.38 251.125 251.581 251.125 261.714C251.125 271.847 279.679 311.519 238.881 311.519C198.083 311.519 226.637 271.831 226.637 261.714C226.637 251.597 220.116 234.38 220.116 234.38Z",
    fill: "#263942"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M403.308 323.294H164.118V372.036H403.308V323.294Z",
    fill: "#1C262B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M167.231 512.835H153.36V489.583H181.789L167.231 512.835Z",
    fill: "#37474F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M276.364 347.657C276.364 349.111 276.795 350.532 277.603 351.74C278.41 352.949 279.558 353.891 280.901 354.447C282.244 355.004 283.722 355.149 285.148 354.866C286.573 354.582 287.883 353.882 288.911 352.854C289.939 351.826 290.639 350.517 290.922 349.091C291.206 347.665 291.06 346.188 290.504 344.845C289.948 343.502 289.006 342.354 287.797 341.546C286.588 340.739 285.167 340.308 283.714 340.308C281.765 340.308 279.895 341.082 278.517 342.46C277.139 343.839 276.364 345.708 276.364 347.657Z",
    fill: "#37474F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M403.308 383.811H164.118V432.553H403.308V383.811Z",
    fill: "#1C262B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M276.364 408.174C276.364 409.628 276.795 411.049 277.603 412.257C278.41 413.466 279.558 414.408 280.901 414.964C282.244 415.521 283.722 415.666 285.148 415.382C286.573 415.099 287.883 414.399 288.911 413.371C289.939 412.343 290.639 411.034 290.922 409.608C291.206 408.182 291.06 406.705 290.504 405.362C289.948 404.019 289.006 402.871 287.797 402.063C286.588 401.256 285.167 400.825 283.714 400.825C281.765 400.825 279.895 401.599 278.517 402.977C277.139 404.356 276.364 406.225 276.364 408.174Z",
    fill: "#37474F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M403.308 444.312H164.118V493.054H403.308V444.312Z",
    fill: "#1C262B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M283.714 476.041C287.773 476.041 291.063 472.75 291.063 468.691C291.063 464.632 287.773 461.341 283.714 461.341C279.655 461.341 276.364 464.632 276.364 468.691C276.364 472.75 279.655 476.041 283.714 476.041Z",
    fill: "#37474F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M578.964 27.356H462.888V109.984H578.964V27.356Z",
    fill: "#263942"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M588.44 27.356H469.486V109.984H588.44V27.356Z",
    fill: "#1C262B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M580.856 102.4V34.9401L477.071 34.9401V102.4H580.856Z",
    fill: "#37474F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M562.592 82.7437V54.5807L495.335 54.5807V82.7437H562.592Z",
    fill: "#1C262B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M673.133 68.6701H602.483V142.76H673.133V68.6701Z",
    fill: "#263942"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M682.64 68.6701H609.098V142.76H682.64V68.6701Z",
    fill: "#1C262B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M675.056 135.176V76.2543H616.681V135.176H675.056Z",
    fill: "#37474F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M634.946 105.715C634.946 103.113 635.979 100.618 637.817 98.7766C639.655 96.9354 642.149 95.8989 644.751 95.8948H646.971C649.573 95.8989 652.067 96.9354 653.905 98.7766C655.744 100.618 656.776 103.113 656.776 105.715C656.776 108.315 655.743 110.809 653.904 112.648C652.066 114.487 649.572 115.52 646.971 115.52H644.829C643.535 115.53 642.252 115.284 641.053 114.796C639.854 114.308 638.764 113.587 637.846 112.676C636.927 111.764 636.198 110.68 635.7 109.485C635.202 108.291 634.946 107.009 634.946 105.715Z",
    fill: "#1C262B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M782.438 167.952H595.884H561.966V211.065H528.048V254.177H494.131V297.289H460.213V340.402H426.296V383.498H392.378V426.611H358.461V469.723H324.543V512.835H358.461H782.438V167.952Z",
    fill: "#37474F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M514.382 469.723H321.057V482.655H514.382V469.723Z",
    fill: "#1C262B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M548.299 426.611H354.974V439.543H548.299V426.611Z",
    fill: "#1C262B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M582.217 383.498H388.892V396.43H582.217V383.498Z",
    fill: "#1C262B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M616.134 340.386H422.809V353.318H616.134V340.386Z",
    fill: "#1C262B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M650.052 297.289H456.727V310.221H650.052V297.289Z",
    fill: "#1C262B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M683.97 254.177H490.645V267.109H683.97V254.177Z",
    fill: "#1C262B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M717.887 211.064H524.562V223.997H717.887V211.064Z",
    fill: "#1C262B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M751.805 167.952H558.479V180.884H751.805V167.952Z",
    fill: "#1C262B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M748.521 167.952V211.065H714.603V254.177H680.685V297.289H646.768V340.402H612.85V383.498H578.933V426.611H545.015V469.723H511.098V512.835H545.015H782.438V211.065V167.952H748.521Z",
    fill: "#37474F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M391.503 583.454C558.952 583.454 694.697 575.529 694.697 565.752C694.697 555.976 558.952 548.051 391.503 548.051C224.053 548.051 88.3086 555.976 88.3086 565.752C88.3086 575.529 224.053 583.454 391.503 583.454Z",
    fill: "#313940"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M298.318 264.404C297.444 260.612 295.311 257.229 292.266 254.806C289.221 252.384 285.445 251.065 281.554 251.065H156.455C151.893 251.065 147.518 252.877 144.292 256.103C141.066 259.329 139.254 263.704 139.254 268.266V546.331C139.254 550.893 141.066 555.268 144.292 558.494C147.518 561.72 151.893 563.532 156.455 563.532H553.646C558.208 563.532 562.583 561.72 565.809 558.494C569.034 555.268 570.847 550.893 570.847 546.331V312.755C570.847 308.193 569.034 303.817 565.809 300.592C562.583 297.366 558.208 295.554 553.646 295.554H337.458C328.372 295.555 319.555 292.475 312.445 286.817C305.336 281.16 300.356 273.258 298.318 264.404Z",
    fill: "url(#paint0_linear_2092_25554)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M298.318 264.404C297.444 260.612 295.311 257.229 292.266 254.806C289.221 252.384 285.445 251.065 281.554 251.065H156.455C151.893 251.065 147.518 252.877 144.292 256.103C141.066 259.329 139.254 263.704 139.254 268.266V546.331C139.254 550.893 141.066 555.268 144.292 558.494C147.518 561.72 151.893 563.532 156.455 563.532H553.646C558.208 563.532 562.583 561.72 565.809 558.494C569.034 555.268 570.847 550.893 570.847 546.331V312.755C570.847 308.193 569.034 303.817 565.809 300.592C562.583 297.366 558.208 295.554 553.646 295.554H337.458C328.372 295.555 319.555 292.475 312.445 286.817C305.336 281.16 300.356 273.258 298.318 264.404Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M254.157 177.804L265.307 213.91C266.73 218.506 269.919 222.348 274.173 224.594C278.428 226.84 283.399 227.306 287.997 225.889L324.088 214.739L254.157 177.804Z",
    fill: "url(#paint1_linear_2092_25554)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M254.158 177.804L125.149 217.663C122.872 218.363 120.755 219.505 118.919 221.023C117.083 222.542 115.565 224.408 114.451 226.514C113.337 228.62 112.649 230.925 112.427 233.297C112.204 235.669 112.452 238.061 113.155 240.338L186.807 478.777C187.51 481.054 188.655 483.169 190.176 485.003C191.697 486.838 193.564 488.354 195.671 489.467C197.778 490.579 200.084 491.265 202.456 491.486C204.828 491.707 207.221 491.459 209.497 490.755L374.613 439.746C376.889 439.045 379.004 437.902 380.838 436.382C382.672 434.863 384.189 432.997 385.301 430.891C386.414 428.786 387.1 426.481 387.322 424.11C387.543 421.739 387.295 419.347 386.591 417.072L324.041 214.739L254.158 177.804Z",
    fill: "url(#paint2_linear_2092_25554)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M254.158 177.804L125.149 217.663C122.872 218.363 120.755 219.505 118.919 221.023C117.083 222.542 115.565 224.408 114.451 226.514C113.337 228.62 112.649 230.925 112.427 233.297C112.204 235.669 112.452 238.061 113.155 240.338L186.807 478.777C187.51 481.054 188.655 483.169 190.176 485.003C191.697 486.838 193.564 488.354 195.671 489.467C197.778 490.579 200.084 491.265 202.456 491.486C204.828 491.707 207.221 491.459 209.497 490.755L374.613 439.746C376.889 439.045 379.004 437.902 380.838 436.382C382.672 434.863 384.189 432.997 385.301 430.891C386.414 428.786 387.1 426.481 387.322 424.11C387.543 421.739 387.295 419.347 386.591 417.072L324.041 214.739L254.158 177.804Z",
    fill: "#37474F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.572 429.332L216.237 462.483C214.23 463.099 212.06 462.896 210.202 461.917C208.344 460.939 206.95 459.264 206.323 457.26C205.712 455.253 205.92 453.085 206.901 451.231C207.883 449.376 209.558 447.985 211.561 447.362L318.897 414.195C320.906 413.579 323.078 413.784 324.936 414.766C326.794 415.748 328.187 417.426 328.811 419.433C329.422 421.44 329.214 423.608 328.233 425.463C327.251 427.317 325.576 428.708 323.572 429.332Z",
    fill: "url(#paint3_linear_2092_25554)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.058 234.771L151.294 252.3C149.287 252.912 147.119 252.707 145.262 251.729C143.406 250.751 142.01 249.079 141.38 247.077C140.768 245.068 140.976 242.898 141.957 241.041C142.938 239.184 144.614 237.79 146.619 237.163L203.382 219.634C205.39 219.013 207.561 219.214 209.42 220.194C211.279 221.173 212.673 222.85 213.297 224.857C213.908 226.866 213.701 229.036 212.719 230.893C211.738 232.75 210.063 234.144 208.058 234.771Z",
    fill: "url(#paint4_linear_2092_25554)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.377 253.364L160.553 282.34C158.55 282.941 156.39 282.729 154.543 281.748C152.695 280.767 151.309 279.098 150.686 277.101C150.069 275.096 150.273 272.928 151.252 271.073C152.231 269.218 153.905 267.826 155.908 267.203L249.733 238.227C251.74 237.61 253.91 237.813 255.768 238.792C257.626 239.771 259.02 241.445 259.647 243.45C260.253 245.463 260.039 247.634 259.052 249.491C258.066 251.348 256.385 252.74 254.377 253.364Z",
    fill: "url(#paint5_linear_2092_25554)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.763 270.08L169.841 312.301C167.836 312.917 165.669 312.713 163.813 311.734C161.958 310.755 160.566 309.081 159.943 307.078C159.331 305.071 159.536 302.903 160.514 301.046C161.492 299.19 163.164 297.794 165.166 297.164L302.087 254.943C304.092 254.331 306.258 254.537 308.112 255.515C309.966 256.494 311.359 258.165 311.986 260.166C312.602 262.173 312.399 264.343 311.42 266.201C310.441 268.059 308.767 269.453 306.763 270.08Z",
    fill: "url(#paint6_linear_2092_25554)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.035 300.104L236.441 324.701C234.433 325.313 232.266 325.105 230.411 324.123C228.557 323.142 227.166 321.466 226.542 319.463C225.93 317.458 226.136 315.292 227.114 313.438C228.093 311.584 229.764 310.191 231.765 309.564L311.359 284.967C313.369 284.359 315.537 284.569 317.393 285.55C319.249 286.53 320.643 288.203 321.274 290.205C321.885 292.213 321.677 294.38 320.695 296.235C319.714 298.089 318.038 299.48 316.035 300.104Z",
    fill: "url(#paint7_linear_2092_25554)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.943 335.976L179.13 342.403C177.123 343.02 174.953 342.816 173.095 341.838C171.237 340.859 169.843 339.184 169.216 337.18C168.6 335.171 168.806 332.999 169.787 331.141C170.769 329.283 172.447 327.89 174.454 327.266L195.268 320.839C197.275 320.227 199.443 320.432 201.3 321.41C203.157 322.389 204.552 324.06 205.182 326.062C205.789 328.071 205.58 330.239 204.599 332.095C203.619 333.951 201.946 335.346 199.943 335.976Z",
    fill: "url(#paint8_linear_2092_25554)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.323 330.143L188.401 372.443C186.394 373.054 184.227 372.846 182.372 371.864C180.517 370.883 179.127 369.207 178.503 367.204C177.887 365.199 178.091 363.031 179.07 361.176C180.049 359.321 181.723 357.929 183.726 357.306L320.647 315.006C322.652 314.395 324.818 314.6 326.672 315.579C328.526 316.557 329.919 318.229 330.546 320.229C331.162 322.237 330.959 324.406 329.98 326.264C329.001 328.122 327.327 329.517 325.323 330.143Z",
    fill: "url(#paint9_linear_2092_25554)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.758 376.493L197.675 402.466C195.67 403.078 193.504 402.872 191.65 401.894C189.796 400.916 188.404 399.244 187.777 397.244C187.165 395.236 187.37 393.068 188.348 391.212C189.326 389.355 190.998 387.96 193 387.329L277.082 361.356C279.092 360.744 281.261 360.952 283.118 361.933C284.975 362.914 286.369 364.59 286.996 366.594C287.612 368.601 287.406 370.771 286.424 372.627C285.442 374.482 283.764 375.873 281.758 376.493Z",
    fill: "url(#paint10_linear_2092_25554)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.598 360.183L312.158 367.11C310.149 367.722 307.979 367.515 306.122 366.533C304.265 365.552 302.871 363.876 302.244 361.872C301.633 359.865 301.841 357.697 302.822 355.842C303.804 353.988 305.479 352.597 307.482 351.973L329.922 345.046C331.927 344.43 334.095 344.634 335.95 345.613C337.806 346.592 339.197 348.266 339.821 350.269C340.437 352.276 340.234 354.446 339.255 356.304C338.276 358.162 336.602 359.556 334.598 360.183Z",
    fill: "url(#paint11_linear_2092_25554)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.868 390.238L206.978 432.459C204.969 433.075 202.797 432.869 200.939 431.888C199.081 430.906 197.688 429.227 197.064 427.22C196.449 425.213 196.655 423.044 197.637 421.188C198.619 419.332 200.297 417.942 202.303 417.322L339.208 375.023C341.218 374.415 343.385 374.625 345.241 375.605C347.097 376.586 348.492 378.259 349.122 380.261C349.436 381.261 349.55 382.313 349.455 383.357C349.361 384.401 349.061 385.416 348.572 386.343C348.084 387.271 347.417 388.092 346.609 388.761C345.802 389.429 344.87 389.931 343.868 390.238Z",
    fill: "url(#paint12_linear_2092_25554)"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M346.81 88.1386L387.748 179.367C388.811 181.749 388.888 184.454 387.962 186.892C387.036 189.33 385.183 191.302 382.807 192.378L209.138 270.33C206.757 271.397 204.05 271.476 201.611 270.55C199.172 269.624 197.2 267.767 196.127 265.389L155.173 174.16C154.101 171.777 154.019 169.067 154.946 166.624C155.873 164.181 157.732 162.206 160.115 161.134L333.784 83.1816C336.169 82.1192 338.879 82.0442 341.319 82.973C343.76 83.9018 345.734 85.759 346.81 88.1386Z",
    fill: "url(#paint13_linear_2092_25554)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M346.81 88.1386L387.748 179.367C388.811 181.749 388.888 184.454 387.962 186.892C387.036 189.33 385.183 191.302 382.807 192.378L209.138 270.33C206.757 271.397 204.05 271.476 201.611 270.55C199.172 269.624 197.2 267.767 196.127 265.389L155.173 174.16C154.101 171.777 154.019 169.067 154.946 166.624C155.873 164.181 157.732 162.206 160.115 161.134L333.784 83.1816C336.169 82.1192 338.879 82.0442 341.319 82.973C343.76 83.9018 345.734 85.759 346.81 88.1386Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M319.44 83.6307L313.89 86.1204L314.53 87.5471L320.08 85.0575L319.44 83.6307Z",
    fill: "url(#paint14_linear_2092_25554)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M306.115 89.5997L288.809 97.3631L289.449 98.7899L306.755 91.0264L306.115 89.5997Z",
    fill: "url(#paint15_linear_2092_25554)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M155.018 183.354L153.592 183.995L158.332 194.551L159.758 193.911L155.018 183.354Z",
    fill: "url(#paint16_linear_2092_25554)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M340.992 82.8532L296.207 170.579C292.051 178.71 285.245 185.18 276.915 188.919C268.584 192.658 259.226 193.442 250.389 191.142L155.079 166.294C156.057 164.008 157.852 162.168 160.114 161.134L333.784 83.1816C336.059 82.1643 338.634 82.047 340.992 82.8532Z",
    fill: "url(#paint17_linear_2092_25554)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M402.558 195.13L267.795 203.449C265.414 203.591 263.084 204.2 260.939 205.243C258.794 206.286 256.876 207.741 255.294 209.527C253.713 211.312 252.499 213.391 251.721 215.646C250.944 217.901 250.619 220.287 250.765 222.667L266.137 471.74C266.28 474.123 266.893 476.453 267.938 478.598C268.984 480.744 270.443 482.662 272.231 484.242C274.019 485.823 276.102 487.035 278.359 487.809C280.617 488.583 283.005 488.904 285.387 488.754L457.868 478.105C460.246 477.961 462.572 477.35 464.714 476.306C466.855 475.262 468.77 473.805 470.347 472.02C471.925 470.235 473.135 468.156 473.907 465.902C474.68 463.648 475 461.264 474.85 458.886L461.871 247.515L402.558 195.13Z",
    fill: "url(#paint18_linear_2092_25554)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M402.558 195.13L267.795 203.449C265.414 203.591 263.084 204.2 260.939 205.243C258.794 206.286 256.876 207.741 255.294 209.527C253.713 211.312 252.499 213.391 251.721 215.646C250.944 217.901 250.619 220.287 250.765 222.667L266.137 471.74C266.28 474.123 266.893 476.453 267.938 478.598C268.984 480.744 270.443 482.662 272.231 484.242C274.019 485.823 276.102 487.035 278.359 487.809C280.617 488.583 283.005 488.904 285.387 488.754L457.868 478.105C460.246 477.961 462.572 477.35 464.714 476.306C466.855 475.262 468.77 473.805 470.347 472.02C471.925 470.235 473.135 468.156 473.907 465.902C474.68 463.648 475 461.264 474.85 458.886L461.871 247.515L402.558 195.13Z",
    fill: "#37474F"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.704 455.915L298.568 462.843C296.473 462.962 294.416 462.249 292.845 460.857C291.275 459.465 290.319 457.509 290.186 455.415C290.066 453.321 290.777 451.264 292.165 449.692C293.553 448.119 295.505 447.158 297.598 447.017L409.734 440.106C411.829 439.981 413.888 440.691 415.461 442.08C417.035 443.469 417.995 445.424 418.131 447.518C418.255 449.615 417.544 451.677 416.151 453.25C414.759 454.824 412.8 455.782 410.704 455.915Z",
    fill: "url(#paint19_linear_2092_25554)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.338 239.618L285.026 243.246C282.932 243.366 280.875 242.655 279.303 241.267C277.73 239.879 276.769 237.927 276.628 235.834C276.508 233.738 277.222 231.679 278.613 230.106C280.004 228.533 281.961 227.574 284.056 227.437L343.369 223.778C345.462 223.654 347.519 224.364 349.09 225.753C350.661 227.142 351.618 229.097 351.75 231.19C351.883 233.29 351.177 235.357 349.788 236.937C348.398 238.518 346.438 239.482 344.338 239.618Z",
    fill: "url(#paint20_linear_2092_25554)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.966 268.61L286.966 274.646C284.87 274.775 282.809 274.066 281.234 272.677C279.66 271.287 278.701 269.33 278.569 267.234C278.444 265.136 279.156 263.075 280.548 261.501C281.941 259.928 283.899 258.969 285.996 258.837L383.98 252.801C386.076 252.672 388.138 253.38 389.712 254.77C391.286 256.16 392.245 258.117 392.378 260.213C392.502 262.308 391.792 264.367 390.403 265.94C389.015 267.513 387.06 268.473 384.966 268.61Z",
    fill: "url(#paint21_linear_2092_25554)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.924 297.211L288.904 306.03C286.803 306.159 284.736 305.449 283.156 304.057C281.576 302.665 280.613 300.704 280.476 298.603C280.352 296.509 281.062 294.452 282.451 292.881C283.84 291.31 285.795 290.354 287.888 290.221L430.923 281.386C433.018 281.266 435.076 281.98 436.646 283.371C438.216 284.763 439.172 286.72 439.305 288.814C439.43 290.903 438.724 292.958 437.342 294.53C435.96 296.103 434.013 297.066 431.924 297.211Z",
    fill: "url(#paint22_linear_2092_25554)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.863 328.58L350.719 333.709C348.624 333.833 346.565 333.123 344.992 331.734C343.418 330.346 342.458 328.391 342.322 326.297C342.193 324.201 342.901 322.139 344.291 320.565C345.681 318.991 347.638 318.032 349.734 317.899L432.878 312.77C434.974 312.642 437.035 313.35 438.609 314.74C440.184 316.129 441.142 318.087 441.275 320.182C441.399 322.277 440.69 324.336 439.301 325.91C437.912 327.483 435.957 328.443 433.863 328.58Z",
    fill: "url(#paint23_linear_2092_25554)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.579 336.054L290.827 337.399C288.734 337.523 286.677 336.813 285.106 335.424C283.535 334.035 282.578 332.08 282.446 329.987C282.321 327.892 283.031 325.833 284.42 324.26C285.809 322.686 287.764 321.726 289.858 321.59L311.609 320.245C313.706 320.125 315.765 320.838 317.338 322.229C318.91 323.621 319.87 325.577 320.007 327.673C320.127 329.767 319.413 331.825 318.021 333.395C316.629 334.965 314.673 335.921 312.579 336.054Z",
    fill: "url(#paint24_linear_2092_25554)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.802 359.948L292.767 368.768C290.672 368.892 288.613 368.182 287.039 366.794C285.466 365.405 284.506 363.45 284.369 361.356C284.249 359.259 284.963 357.2 286.354 355.627C287.745 354.055 289.702 353.095 291.797 352.958L434.817 344.139C436.915 344.015 438.976 344.727 440.55 346.119C442.123 347.511 443.082 349.47 443.214 351.567C443.339 353.66 442.628 355.717 441.239 357.288C439.85 358.859 437.895 359.816 435.802 359.948Z",
    fill: "url(#paint25_linear_2092_25554)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.54 394.726L294.704 400.152C292.608 400.272 290.549 399.559 288.976 398.167C287.403 396.776 286.444 394.82 286.307 392.724C286.187 390.629 286.901 388.572 288.293 387.002C289.684 385.432 291.641 384.476 293.735 384.343L381.57 378.916C383.665 378.797 385.722 379.51 387.293 380.902C388.863 382.294 389.819 384.25 389.952 386.344C390.08 388.439 389.371 390.498 387.981 392.07C386.591 393.642 384.634 394.597 382.54 394.726Z",
    fill: "url(#paint26_linear_2092_25554)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.725 391.333L414.269 392.771C412.175 392.895 410.118 392.185 408.547 390.796C406.976 389.407 406.02 387.452 405.887 385.359C405.758 383.263 406.467 381.202 407.856 379.628C409.246 378.053 411.203 377.095 413.299 376.962L436.755 375.523C438.851 375.395 440.912 376.103 442.487 377.493C444.061 378.882 445.02 380.84 445.152 382.935C445.272 385.032 444.559 387.091 443.168 388.664C441.777 390.236 439.82 391.196 437.725 391.333Z",
    fill: "url(#paint27_linear_2092_25554)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.665 422.701L296.645 431.521C294.55 431.645 292.491 430.935 290.917 429.546C289.344 428.158 288.384 426.203 288.247 424.109C288.123 422.014 288.833 419.955 290.222 418.381C291.61 416.808 293.565 415.848 295.659 415.711L438.695 406.892C440.788 406.768 442.846 407.478 444.416 408.867C445.987 410.256 446.944 412.211 447.077 414.304C447.205 416.4 446.497 418.461 445.107 420.035C443.718 421.61 441.76 422.568 439.665 422.701Z",
    fill: "url(#paint28_linear_2092_25554)"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M402.557 195.13L404.887 232.847C405.032 235.225 405.645 237.552 406.689 239.693C407.734 241.834 409.19 243.749 410.975 245.327C412.759 246.906 414.837 248.117 417.09 248.892C419.343 249.668 421.727 249.991 424.105 249.845L461.869 247.515L402.557 195.13Z",
    fill: "url(#paint29_linear_2092_25554)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.428 289.22C358.404 287.413 358.019 285.628 357.294 283.972C356.569 282.317 355.52 280.823 354.208 279.579C352.896 278.336 351.348 277.368 349.655 276.733C347.963 276.098 346.161 275.808 344.354 275.882H219.099C209.607 275.882 200.334 283.591 198.551 293.083L149.121 546.331C147.276 555.823 153.468 563.532 162.96 563.532H560.151C569.643 563.532 578.838 555.838 580.698 546.331L621.465 337.571C623.31 328.064 617.118 320.37 607.626 320.37H391.501C372.736 320.37 359.069 307.454 358.428 289.22Z",
    fill: "url(#paint30_linear_2092_25554)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2092_25554",
    x1: 248.549,
    y1: 209.932,
    x2: 544.316,
    y2: 558.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2092_25554",
    x1: 271.866,
    y1: 171.368,
    x2: 317.854,
    y2: 227.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2092_25554",
    x1: 182.001,
    y1: 136.5,
    x2: 470.782,
    y2: 352.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2092_25554",
    x1: 237.171,
    y1: 407.397,
    x2: 273.158,
    y2: 484.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2092_25554",
    x1: 159.422,
    y1: 214.887,
    x2: 186.148,
    y2: 264.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2092_25554",
    x1: 178.103,
    y1: 231.979,
    x2: 211.582,
    y2: 301.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2092_25554",
    x1: 198.276,
    y1: 246.955,
    x2: 239.673,
    y2: 339.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2092_25554",
    x1: 250.361,
    y1: 279.305,
    x2: 281.246,
    y2: 341.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2092_25554",
    x1: 178.15,
    y1: 317.563,
    x2: 198.327,
    y2: 345.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2092_25554",
    x1: 216.833,
    y1: 307.009,
    x2: 258.317,
    y2: 400.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2092_25554",
    x1: 212.733,
    y1: 355.508,
    x2: 244.434,
    y2: 420.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2092_25554",
    x1: 311.591,
    y1: 341.7,
    x2: 332.075,
    y2: 371.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2092_25554",
    x1: 235.403,
    y1: 367.03,
    x2: 276.881,
    y2: 460.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2092_25554",
    x1: 213.639,
    y1: 57.4644,
    x2: 394.54,
    y2: 248.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2092_25554",
    x1: 315.211,
    y1: 85.3021,
    x2: 317.093,
    y2: 87.4729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2092_25554",
    x1: 293.107,
    y1: 95.2093,
    x2: 294.586,
    y2: 97.8041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2092_25554",
    x1: 153.329,
    y1: 182.443,
    x2: 155.754,
    y2: 181.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2092_25554",
    x1: 202.159,
    y1: 67.8281,
    x2: 301.123,
    y2: 210.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2092_25554",
    x1: 307.496,
    y1: 156.472,
    x2: 565.202,
    y2: 324.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2092_25554",
    x1: 322.58,
    y1: 437.095,
    x2: 331.305,
    y2: 478.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2092_25554",
    x1: 295.646,
    y1: 221.197,
    x2: 306.055,
    y2: 255.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2092_25554",
    x1: 307.382,
    y1: 249.906,
    x2: 316.377,
    y2: 289.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2092_25554",
    x1: 320.69,
    y1: 278.125,
    x2: 329.029,
    y2: 323.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2092_25554",
    x1: 367.373,
    y1: 309.995,
    x2: 376.779,
    y2: 347.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2092_25554",
    x1: 291.95,
    y1: 317.97,
    x2: 305.671,
    y2: 343.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2092_25554",
    x1: 324.589,
    y1: 340.879,
    x2: 332.917,
    y2: 386.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2092_25554",
    x1: 312.548,
    y1: 376.105,
    x2: 321.816,
    y2: 414.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2092_25554",
    x1: 415.823,
    y1: 373.234,
    x2: 429.319,
    y2: 399.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2092_25554",
    x1: 328.462,
    y1: 403.632,
    x2: 336.791,
    y2: 449.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2092_25554",
    x1: 417.577,
    y1: 187.923,
    x2: 469.942,
    y2: 236.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2092_25554",
    x1: 268.575,
    y1: 238.002,
    x2: 529.438,
    y2: 604.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage4);
export default __webpack_public_path__ + "static/media/Image 4.958b110097b3d17deff6f7432e0f582e.svg";
export { ForwardRef as ReactComponent };